export default "__VITE_ASSET__CyaTBZ$x__"